import {Pipe, PipeTransform} from '@angular/core';
import {RecipeCostingDto} from '../../../Models/YuChef/Recipes-costing/recipe-costing.interface';

@Pipe({
  name: 'recipesCosting',
  standalone: false
})
export class RecipesCostingPipe implements PipeTransform {

  transform(items: RecipeCostingDto[], filter: {
    id_local?: number,
    id_familia?: number,
    id_partida?: number | null
  }): RecipeCostingDto[] {

    if (!items || items.length === 0) {
      return [];
    }

    if (filter.id_local) {
      items = items.filter((item) => item['locales'].includes(Number(filter.id_local)) || item['locales'].length === 0);
    }

    if (filter.id_familia) {
      items = items.filter((item) => item['id_familia'] === filter.id_familia);
    }

    if (filter.id_partida) {
      items = items.filter((item) => item['partidas'].includes(Number(filter.id_partida)));
    }

    if (filter.id_partida === 0) {
      items = items.filter((item) => item['partidas'].length === 0);
    }

    return items;

  }

}
